import { observer } from 'mobx-react-lite'

import { Container } from '@components/layout/grid'
import PhoneVerification from '@components/playbook/phone-verification'
import type { PageWithContext } from '@lib/utils/context'
import { getPlaybookLayout } from '@page-templates/playbook-page'

export const PhoneVerificationPage: PageWithContext = observer(() => {
    return (
        <Container>
            <PhoneVerification />
        </Container>
    )
})

PhoneVerificationPage.getLayout = getPlaybookLayout()

export default PhoneVerificationPage
